import { useShopContent } from '@/features/storefront/content/useContent';
import { maintenanceTime, useMaintenance } from '@/features/system/maintenance';

/**
 * Why the shop cannot take an order or a booking right now, or null when it can.
 *
 * During read-only maintenance the shop is still browsable but anything that
 * writes - placing an order, booking a slot - is refused by the server. The
 * button says so before the shopper presses it, rather than after they have
 * filled in an address.
 */
export function useCheckoutPause(): string | null {
  const text = useShopContent();
  const maintenance = useMaintenance();
  if (!maintenance || maintenance.mode !== 'READ_ONLY') return null;
  const time = maintenanceTime(maintenance.endsAt);
  return time
    ? text('maintenance.checkout_paused', { time })
    : text('maintenance.checkout_paused_shortly');
}
